
import styles from './subscribe.module.css';

export default function DesignPage() {

  document.title = `Subscriptions | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Hanuman Editions offers subscription models that encompass all of our titles and box sets.`);


  return (
    <div className='newPageContainer'>
      <div className={styles.subscribeContainer}>
        <h5>Subscriptions</h5>
        <div>
          <p>Hanuman Editions publishes a series of six issues every year and are available for purchase individually, or in limited edition collectors box sets. In response to a tremendous wave of patronage, as of Series III (2025), we have made possible three tiers for annual subscriptions* for greater access to our books.</p>
          <p>*Applies only to current and forthcoming titles</p>
        </div>
        <div className={styles.subscriptionCard}>
          <div className={`${styles.subscriptionCardImage} ${styles.threeBooks}`}
            style={{ backgroundImage: `url(../../Subscriptions/Sub_3Books-min.png)` }}
          ></div>
          <div className={styles.subscriptionCardContent}>
            <div className={styles.subscriptionTitle}>3 Book Subscription</div>
            <div>
              <a href='https://buy.stripe.com/28EfZh3Eibkj4xV8b2frW02' className={styles.subscribe}>
                <span className={styles.price}>$38</span>
                <span className={styles.priceDescription}>/ 3 books / once per year</span>
              </a>
            </div>
            <div>
              <div>Features a standard issue of 3 titles selected for you from the most recent Hanuman Editions series.</div>
              <div>+</div>
              <div>10% off all special release titles published within a year</div>
            </div>
          </div>
        </div>
        <div className={styles.subscriptionCard}>
          <div className={`${styles.subscriptionCardImage} ${styles.sixBooks}`}
            style={{ backgroundImage: `url(../../Subscriptions/Subs_6_Books.png)` }}
          ></div>
          <div className={styles.subscriptionCardContent}>
            <div className={styles.subscriptionTitle}>6 Book Subscription</div>
            <div>
              <a href='https://buy.stripe.com/14AcN52Ae0FF7K7ezqfrW03' className={styles.subscribe}>
                <span className={styles.price}>$75</span>
                <span className={styles.priceDescription}>/ 6 books / once per year</span>
              </a>
            </div>
            <div>
              <div>Features a standard issue of each title in a Hanuman Editions series.</div>
              <div>+</div>
              <div>10% off all special release titles published within a year</div>
            </div>
          </div>
        </div>
        <div className={styles.subscriptionCard}>
          <div className={`${styles.subscriptionCardImage} ${styles.boxSets}`}
            style={{ backgroundImage: `url(../../Subscriptions/Sub_Boxsets-min.png)` }}
          ></div>
          <div className={styles.subscriptionCardContent}>
            <div className={styles.subscriptionTitle}>Box Set Subscription</div>
            <div>
              <a href='https://buy.stripe.com/8x23cv2Ae5ZZ2pNfDufrW04' className={styles.subscribe}>
                <span className={styles.price}>$99</span>
                <span className={styles.priceDescription}>/ 1 box set / once per year</span>
              </a>
            </div>
            <div>
              <div>For each series of Hanuman Editions, we produce a limited quantity of exquisitely designed and hand-numbered box sets in four colourways. This subscription guarantees that you get a set.</div>
              <div>+</div>
              <div>15% off all special release titles published within a year</div>
              <div>+</div>
              <div>Exclusive dispatches from us via email, with behind-the-scenes looks at our design process, production, interviews and supplementary materials, as well as early access to pre-orders for special editions.</div>
            </div>
          </div>
        </div>
      </div>

    </div >
  )
}